import React from 'react'
import { AppDataTable, NoDataFound } from '@components'
import { useGroupingExportsData } from 'Pages/ReportsAlerts/ExportsGrouping/@hooks'
import { Skeleton } from '@mui/material'
import GroupedExportsTableToolbar from 'Pages/Admin/GroupedExports/Table/Toolbar'
import { filenameColumn, createdColumn, timestampExportColumn, exportedColumn, infoColumn } from 'Pages/ReportsAlerts/ExportsGrouping/Table/@columns'
import { formatDate } from '@ui-seeker/utils'
import { groupedExportsDateRange } from 'Pages/Admin/GroupedExports/@signals'
import { isTourDemoActive } from '@signals/app'
import { groupingExecutionType } from 'Pages/ReportsAlerts/ExportsGrouping/@signals'


export default function GroupingExportsTable() {

	const { data, isLoading } = useGroupingExportsData()

	if (isLoading) return <Skeleton variant="rectangular" height={600}/>

	if (!data?.length) return isTourDemoActive.value ? null : <NoDataFound/>

	return <AppDataTable
		title={`${groupingExecutionType.value === 'one_way_generation' ? 'Grouped Reports' : 'Grouped Exports'} List ${formatDate(groupedExportsDateRange.value[0], { format: 'dd MMM yyyy' })} - ${formatDate(groupedExportsDateRange.value[1], { format: 'dd MMM yyyy' })}`}
		data={data}
		options={{
			selectableRows: 'multiple',
			customToolbarSelect: (selectedData, setSelectedRows) => <GroupedExportsTableToolbar
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}/>,
		}}
		columns={[ ...filenameColumn(), createdColumn(), timestampExportColumn(), ...exportedColumn(), infoColumn() ]}/>
}